module.exports = __webpack_public_path__ + "img/cases-brand-hpnk-lazyload-68.997069fc.gif";